import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import DataParser from "../../../utlits/Dataparser";
import UserServices from "../../../Services/UserService";

const Welcome = () => {
    const navigate = useNavigate();
    const [fadeIn, setFadeIn] = useState(false);

    // Get user ID to track if they've seen the welcome screen
    const userId = DataParser.UserId();

    useEffect(() => {
        setFadeIn(true);
    }, []);

    const handleGetStarted = () => {
        if (!userId) {
            console.warn("User ID missing, skipping update");
            navigate(`/${DataParser.CompanyIdentifierRole()}/dashboard`);
            return;
        }

        // Mark as seen in Database
        UserServices.updateWelcomeSeen(userId).then(() => {
            // Continue navigation
            const adminInfoObj = JSON.parse(secureLocalStorage.getItem("adminInfo"));
            const role = adminInfoObj?.user?.userdata?.role_title || "";
            const roleLower = role.toLowerCase();
            const userPermissions = adminInfoObj?.user?.userdata?.user_permissions || [];

            if (roleLower === "hr") {
            navigate(`${DataParser.CompanyUrlPrefix()}/dashboard`);
            } else if (roleLower === "company admin") {
                navigate(`${DataParser.CompanyUrlPrefix()}/employee-attendance`);
            } else {
                // Dynamic Redirection for Employees
                if (userPermissions.includes("myattendance-list")) {
                    navigate(`${DataParser.CompanyUrlPrefix()}/employee-attendance`);
                } else if (userPermissions.includes("tasks-list")) {
                    navigate(`${DataParser.CompanyUrlPrefix()}/tasks`);
                } else if (userPermissions.includes("myleave-list")) {
                    navigate(`${DataParser.CompanyUrlPrefix()}/employee_leaves`);
                } else if (userPermissions.includes("myevaluation-list")) {
                    navigate(`${DataParser.CompanyUrlPrefix()}/myevaluation`);
                } else {
                    navigate(`${DataParser.CompanyUrlPrefix()}/employee-attendance`);
                }
            }
        }).catch(err => {
            console.error("Failed to update welcome status", err);
            // Navigate anyway?
            navigate(`${DataParser.CompanyUrlPrefix()}/dashboard`);
        });
    };

    return (
        <>
            <Helmet>
                <title>Welcome - Planit</title>
            </Helmet>
            <div
                className="d-flex justify-content-center align-items-center vh-100 position-relative"
                style={{
                    background: "linear-gradient(135deg, #f0f4f8 0%, #f2fffb 100%)",
                    fontFamily: "'Inter', sans-serif",
                    overflow: "hidden",
                }}
            >
                {/* Abstract Background Shapes */}
                <div
                    style={{
                        position: "absolute",
                        top: "-10%",
                        right: "-5%",
                        width: "500px",
                        height: "500px",
                        borderRadius: "50%",
                        background: "linear-gradient(45deg, #0DDFAB 0%, #34efbf 100%)",
                        opacity: "0.05",
                        filter: "blur(80px)",
                        zIndex: 0,
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        bottom: "-10%",
                        left: "-5%",
                        width: "600px",
                        height: "600px",
                        borderRadius: "50%",
                        background: "linear-gradient(45deg, #0bc698 0%, #0DDFAB 100%)",
                        opacity: "0.05",
                        filter: "blur(100px)",
                        zIndex: 0,
                    }}
                />

                <div
                    className={`text-center position-relative ${fadeIn ? "fade-in-up" : ""}`}
                    style={{
                        maxWidth: "900px",
                        padding: "0 20px",
                        zIndex: 1,
                        opacity: fadeIn ? 1 : 0,
                        transform: fadeIn ? "translateY(0)" : "translateY(30px)",
                        transition: "all 1s cubic-bezier(0.2, 0.8, 0.2, 1)",
                    }}
                >
                    <h6
                        className="text-uppercase mb-3"
                        style={{
                            color: "#0DDFAB",
                            letterSpacing: "3px",
                            fontWeight: "700",
                            fontSize: "0.9rem",
                        }}
                    >
                        {/* Human Resource Management System */}
                    </h6>
                    <h1
                        className="mb-4"
                        style={{
                            fontSize: "3.5rem",
                            fontWeight: "800",
                            color: "#2c3e50",
                            letterSpacing: "-0.5px",
                            lineHeight: "1.2",
                        }}
                    >
                        Welcome to <span style={{ color: "#0DDFAB" }}>Planit</span>
                    </h1>
                    <p
                        className="mb-5 mx-auto"
                        style={{
                            fontSize: "1.25rem",
                            color: "#64748b",
                            fontWeight: "400",
                            maxWidth: "650px",
                            lineHeight: "1.8",
                        }}
                    >
                        <b>We’re glad to have you on board!</b> <br />
                        Access your work tools, manage your tasks, and stay connected with your team — all in one place.
                    </p>

                    <button
                        onClick={handleGetStarted}
                        className="btn btn-lg"
                        style={{
                            backgroundColor: "#0DDFAB",
                            color: "#000",
                            padding: "16px 48px",
                            borderRadius: "8px",
                            fontSize: "1.1rem",
                            fontWeight: "600",
                            border: "none",
                            boxShadow: "0 20px 40px -10px rgba(13, 223, 171, 0.3)",
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                            letterSpacing: "0.5px",
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = "translateY(-3px)";
                            e.currentTarget.style.boxShadow =
                                "0 25px 50px -12px rgba(13, 223, 171, 0.4)";
                            e.currentTarget.style.backgroundColor = "#0bc698";
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow =
                                "0 20px 40px -10px rgba(13, 223, 171, 0.3)";
                            e.currentTarget.style.backgroundColor = "#0DDFAB";
                        }}
                    >
                        Get Started
                    </button>
                </div>
            </div>
        </>
    );
};

export default Welcome;
